// removed by extract-text-webpack-plugin
module.exports = {"addPatientPage":"_3NPaNU7O6BsfdKewtMaPJY","form":"QF5W2jD4UcI_0Kv2N8due"};


//////////////////
// WEBPACK FOOTER
// ./client/src/styles/AddPatientPage.scss
// module id = 576
// module chunks = 0